import React, { useEffect, useRef, useState } from "react";
import { Outlet, Link } from "react-router-dom";

export default function Layout() {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    const onClick = (e) => {
      if (!open) return;
      if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    window.addEventListener("mousedown", onClick);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("mousedown", onClick);
    };
  }, [open]);

  return (
    <div className="swordfish-container">
      {/* Top bar */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          background: "#000",
          borderBottom: "2px solid #d4af37"
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <Link to="/" style={{ textDecoration: "none", color: "#ffd700" }}>
            <div style={{ fontFamily: "Arial Black, sans-serif", letterSpacing: "-0.02em" }}>
                SWORDFISHTROMBONE
            </div>
          </Link>

          {/* Hamburger */}
          <div style={{ position: "relative" }}>
            <button
              onClick={() => setOpen((v) => !v)}
              aria-label="Open menu"
              style={{
                background: "transparent",
                border: "1px solid rgba(212,175,55,0.7)",
                color: "#ffd700",
                padding: "8px 10px",
                borderRadius: 10,
                cursor: "pointer",
                fontSize: 18,
                lineHeight: 1
              }}
            >
              {open ? "✕" : "☰"}
            </button>

            {/* Narrow dropdown on the RIGHT */}
            {open && (
              <div
                ref={panelRef}
                style={{
                  position: "absolute",
                  right: 0,
                  top: "calc(100% + 10px)",
                  width: 220,          // narrow
                  maxWidth: "75vw",
                  border: "1px solid rgba(212,175,55,0.7)",
                  borderRadius: 12,
                  overflow: "hidden",
                  background: "#050505",
                  boxShadow: "0 12px 40px rgba(0,0,0,0.6)"
                }}
              >
                <MenuItem to="/" label="Home" onPick={() => setOpen(false)} />
                <MenuItem to="/artists" label="Artists" onPick={() => setOpen(false)} />
                <MenuItem to="/songs" label="Songs" onPick={() => setOpen(false)} />
                <MenuItem to="/news" label="News" onPick={() => setOpen(false)} />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Page content */}
      <Outlet />
    </div>
  );
}

function MenuItem({ to, label, onPick }) {
  return (
    <Link
      to={to}
      onClick={onPick}
      style={{
        display: "block",
        padding: "12px 14px",
        textDecoration: "none",
        color: "#ffd700",
        borderBottom: "1px solid rgba(212,175,55,0.25)"
      }}
    >
      {label}
    </Link>
  );
}
